import { useCommandDialog } from '@/features/command-dialog';
import { useAnalytics } from '@/services/analytics';
import { PlainButton, KeyboardShortcut, TextField, Box } from '@customerio/pluma-components/react';
import * as topNavStyles from '../../index.css';

export function CommandDialogButton() {
  const commandDialog = useCommandDialog();
  const { track } = useAnalytics();

  const handleClick = () => {
    void track('commandDialog', 'opened', { 'Entry Point': 'header' });
    commandDialog.toggle();
  };

  return (
    <Box className={topNavStyles.searchPaletteInputContainer}>
      <PlainButton
        className={topNavStyles.searchPaletteInputButton}
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
      >
        <TextField
          ariaLabel="Search"
          placeholder="Search…"
          icon="search"
          size="sm"
          unsafe_inputWrapperClassName={topNavStyles.searchPaletteInputWrapper}
          unsafe_rightSectionComponent={<KeyboardShortcut hotkey="Mod+K" mr="050" />}
          readOnly={true}
          onClick={(e) => {
            e.preventDefault();
          }}
          flexGrow="1"
        />
      </PlainButton>
    </Box>
  );
}
